import React from 'react';
// template imports
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import PiggyBank from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PiggybankWithCoin';
import ShieldWithDollarSign from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/ShieldWithDollarSign';
import WalletIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/Wallet';
// native components
import UnderstandingProductGrouping from '../../../../components/understandingProductGrouping/understandingProductGrouping';
// styles
import { ColStyled } from './styles';

export const ITEMS = [
  {
    id: 'income-annuities-are-affordable',
    icon: PiggyBank,
    title: 'Income annuities give you guaranteed income in retirement.',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        An income annuity can help you make sure you&#39;re ready for whatever life throws at you. It means you won&#39;t outlive the income stream and won&#39;t have to worry about running out of money in retirement. And it means you won&#39;t be at the mercy of the markets or the future of Social Security when you&#39;re ready to retire.
      </Typography>
    ),
  },
  {
    id: 'income-annuities-wont-lose-money',
    icon: ShieldWithDollarSign,
    title: <>You won&#39;t lose your money if you pass away sooner than expected.</>,
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Many of our income annuities come with an optional death benefit feature to make sure your loved ones will get back at least what you&#39;ve put into your annuity if you pass away before your income payments start.
      </Typography>
    ),
  },
  {
    id: 'income-annuities-is-it-affordable',
    icon: WalletIcon,
    title: 'Annuities are more affordable than many people think.',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Like with all financial products, annuities do come with some costs. But depending on the type of annuity you purchase, it could come with some big benefits like tax deferral, a minimum death benefit, and&#47;or guaranteed income for life. Even better, the income from your annuity will never go down&#8212;in fact, some annuities earn dividends, meaning your income could go up over time.
      </Typography>
    ),
  },
];

export default () => {
  return (
    <UnderstandingProductGrouping
      id='income-annuities'
      backgroundVariant='lightB'
      headingText={<>What to know about <WidowBlock>income annuities:</WidowBlock></>}
      cardDataArray={ITEMS}
      secondaryContent={
        <Row align='center'>
          <ColStyled>
            <Link
              id='income-annuities-understanding-product-cta-fafa'
              variant='buttonLinkPrimary'
              themeType='lightTheme'
              ariaLabel='Get your income annuities questions answered with a financial advisor'
              linkUrl='/find-a-financial-advisor/'>
              Get started
            </Link>
          </ColStyled>
        </Row>
      }
    />
  );
};
